const swiper = new Swiper(".swiper-slider-25", {
  // Optional parameters
  centeredSlides: false,
  slidesPerView: 4,
  grabCursor: true,
  freeMode: true,
  loop: true,
  mousewheel: false,
  keyboard: {
    enabled: true
  },

  // Enabled autoplay mode
  autoplay: {
     enabled: false,
    delay: 3000,
    disableOnInteraction: false
  },

  // If we need pagination
  // pagination: {
  //   el: ".swiper-pagination",
  //   dynamicBullets: false,
  //   clickable: true
  // },

  // If we need navigation
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  // Responsive breakpoints
  breakpoints: {
    484: {
      slidesPerView: 1.25,
      spaceBetween: 8
    },
    679: {
      slidesPerView: 1.5,
      spaceBetween: 8
    },
    767: {
      slidesPerView: 2.1,
      spaceBetween: 8
    },
    933: {
      slidesPerView: 2.2,
      spaceBetween: 8
    },
    1024: {
      slidesPerView: 2.8,
      spaceBetween: 8
    },
    1440: {
      slidesPerView: 3.8,
      spaceBetween: 8
    },
    1590: {
      slidesPerView: 3.8,
      spaceBetween: 8
    }
  }
});






 const swiper2 = new Swiper(".fyw-health-slide-2", {
  // Optional parameters
  centeredSlides: false,
  slidesPerView: 5,
  spaceBetween: 10,
  grabCursor: true,
  freeMode: false,
  loop: true,
  mousewheel: false,
  keyboard: {
    enabled: true
  },

  // Enabled autoplay mode
  autoplay: {
     enabled: false,
    delay: 3000,
    disableOnInteraction: false
  },

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: false,
    clickable: true
  },

  // If we need navigation
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

  // Responsive breakpoints
  breakpoints: {
    484: {
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.4,
      spaceBetween: 8
    },
    679: {
      slidesPerView: 1.5,
      spaceBetween: 8
    },
    767: {
      slidesPerView: 1.9,
      spaceBetween: 8
    },
    933: {
      slidesPerView: 2.2,
      spaceBetween: 8
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 8
    },
    1625: {
      slidesPerView: 4,
      spaceBetween: 8
    }
  }
});




var swiper3 = new Swiper(".fyw-testimonial-slider", {
  slidesPerView: 3.01,
  spaceBetween: 16,
  centeredSlides: true,
  loop: true,
  breakpoints: {
    1920:{
      slidesPerView: 2.6,
    },
    1279: {
      slidesPerView: 3,
    },
    960: {
      slidesPerView: 2,
    },
    645: {
      slidesPerView: 1.1,
      spaceBetween: 6,
      centeredSlides: true,
    },
  }
});





var swiper4 = new Swiper(".mySwiper-2", {
  slidesPerView: 3,
  spaceBetween: 16,
  centeredSlides: false,
  loop: false,
  breakpoints: {
    1279: {
      slidesPerView: 3,
    },
    960: {
      slidesPerView: 2.5,
    },
    645: {
      slidesPerView: 1.1,
      spaceBetween: 6,
      centeredSlides: true,
    },
  }
});

// // Product tab section
//  document.addEventListener('DOMContentLoaded', function () {
//         // --- Tab Switching Logic ---
//         const tabs = [
//             { buttonId: 'pills-1-pack-tab', boxClass: 'pack-1-box' },
//             { buttonId: 'pills-2-pack-tab', boxClass: 'pack-2-box' },
//             { buttonId: 'pills-3-pack-tab', boxClass: 'pack-3-box' }
//         ];

//         tabs.forEach(tab => {
//             const button = document.getElementById(tab.buttonId);
//             button.addEventListener('click', function () {
//                 tabs.forEach(t => {
//                     document.querySelectorAll('.' + t.boxClass).forEach(el => {
//                         if (t.boxClass === tab.boxClass) {
//                             el.classList.remove('d-none');
//                         } else {
//                             el.classList.add('d-none');
//                         }
//                     });
//                 });
//             });
//         });

//         // --- Handle toggle between One Time Purchase and Subscribe ---
//         document.querySelectorAll('.pack-1-box, .pack-2-box, .pack-3-box').forEach(packBox => {
//             const oneTime = packBox.querySelector('.pack-1-text');
//             const subscribe = packBox.querySelector('.pack-1-subscribe');

//             if (oneTime && subscribe) {
//                 const oneTimeOffer = oneTime.querySelector('.pack-1-text-offer');
//                 const subscribeHide = subscribe.querySelector('.d-none'); // inactive content
//                 const subscribeShow = subscribe.querySelector('.d-block'); // active content

//                 const activateOneTime = () => {
//                     oneTime.classList.add('active');
//                     subscribe.classList.remove('active');

//                     // Show one-time offer
//                     if (oneTimeOffer) oneTimeOffer.classList.add('active');

//                     // Subscribe state (inactive)
//                     if (subscribeHide) {
//                         subscribeHide.classList.remove('d-block');
//                         subscribeHide.classList.add('d-none');
//                     }
//                     if (subscribeShow) {
//                         subscribeShow.classList.remove('d-none');
//                         subscribeShow.classList.add('d-block');
//                     }
//                 };

//                 const activateSubscribe = () => {
//                     subscribe.classList.add('active');
//                     oneTime.classList.remove('active');

//                     // Hide one-time offer
//                     if (oneTimeOffer) oneTimeOffer.classList.remove('active');

//                     // Subscribe state (active)
//                     if (subscribeHide) {
//                         subscribeHide.classList.remove('d-none');
//                         subscribeHide.classList.add('d-block');
//                     }
//                     if (subscribeShow) {
//                         subscribeShow.classList.remove('d-block');
//                         subscribeShow.classList.add('d-none');
//                     }
//                 };

//                 // Default: one time active on load
//                 activateSubscribe();

//                 oneTime.addEventListener('click', activateOneTime);
//                 subscribe.addEventListener('click', activateSubscribe);
//             }
//         });
//     });

